(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("formonlineApp")

.constant("ENV", "prod")

.constant("VERSION", "${revision}")

.constant("ERROR_PREFIX", "error.")

;
})();
